import Toaster, { toasterContext } from './Toaster';

export { toasterContext };
export default Toaster;
